export const colorForCentro = (id: number | null | undefined): string => {
  if (id == null) return '#b0bec5'; // gris para "Todos"
  const palette: Record<number, string> = {
    1: '#90caf9', // Moraleja → azul
    2: '#f48fb1', // Chamartín → rosa
    3: '#ffe082', // Pozuelo → amarillo
    4: '#53dc0e', // Other → verde lima
  };
  return palette[id] ?? '#b0bec5';
};
